var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"installationDetail_ActionCam"},[[_c('div',{staticClass:"card"},[_c('ActioncamList',{attrs:{"installation-id":_vm.installationId}})],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }